// ReportStatus.ts
// Enum for report lifecycle states

export enum ReportStatus {
    CREATED = 0,
    PENDING_RESPONSE = 1,
    ACCEPTED = 2,
    DISPUTED = 3,
    CONCILIATION = 4,
    AGREEMENT_REACHED = 5,
    CONCILIATION_EXPIRED = 6,
    JURY_PHASE = 7,
    JURY_VOTING = 8,
    JURY_VALID = 9,
    JURY_INVALID = 10,
    STAFF_REVIEW = 11,
    CLOSED = 12,
    /** Multi-staff Accept/Reject voting after post-jury party choice */
    STAFF_VOTING = 13
}

/** Finished outcomes — progress UI should show checkmark, not an active spinner. */
export function isTerminalReportStatus(status: ReportStatus): boolean {
    return (
        status === ReportStatus.CLOSED ||
        status === ReportStatus.ACCEPTED ||
        status === ReportStatus.AGREEMENT_REACHED
    );
}
